import { render, staticRenderFns } from "./CostBearerBookingInvoicePreview.vue?vue&type=template&id=041757fb&scoped=true&"
import script from "./CostBearerBookingInvoicePreview.vue?vue&type=script&lang=ts&"
export * from "./CostBearerBookingInvoicePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041757fb",
  null
  
)

export default component.exports